import React from "react";
import { Route, Routes } from "react-router-dom";
import AgTechWebAppHeaderMemo from "./Layout/AgTechWebAppHeader";
import AgTechStandardSidebarNavigation from "./Navigation/AgTechStandardSidebarNavigation";
import { AgTechWebApplication } from "../../../../application/AgTechWebApplication";
import AgTechPageErrorBoundary from "../../../Pages/Error/AgTechPageErrorBoundary";
import { AgTechFeatureContext } from "@agtech/core/features/AgTechFeatures";

declare type AgTechWebAppSurfaceProps = {
    app: AgTechWebApplication,
    path: string
}

const AgTechWebAppSurface = (props: AgTechWebAppSurfaceProps) => {
    const showHeader = props.app.structure.header?.show ?? true;

    return (
        <AgTechFeatureContext app={props.app}>
            <div className="tall border-r row-based bg-appSideNavBackground flex">
                <AgTechWebAppNavigationMemo app={props.app} />
            </div>
            <div className="row-based flex-1 overflow-hidden flex">
                {showHeader && (
                    <div className="wide row-based justify-center border-b bg-appHeader h-[56px] min-h-[56px] flex">
                        <div className="tall column-based items-center ml-auto flex">
                            <AgTechWebAppHeaderMemo app={props.app} />
                        </div>
                    </div>
                )}
                <div className="wide flex-1 bg-surface overflow-hidden flex">
                    <div className="stretched overflow-auto flex">
                        <AgTechWebAppBodyMemo {...props} /> 
                    </div>
                </div>
            </div>
        </AgTechFeatureContext>
    );
};

const AgTechWebAppNavigation = (props: { app: AgTechWebApplication}) => {
    return props.app.structure.sideNavigation ? props.app.structure.sideNavigation(props.app) : (
        <AgTechStandardSidebarNavigation app={props.app} />
    );
};

const AgTechWebAppNavigationMemo = React.memo(AgTechWebAppNavigation);

declare type AgTechAppRoutesProps = {
    app: AgTechWebApplication,
}

const AgTechWebAppBody = (props: AgTechAppRoutesProps) => {
    const appAreas = props.app.structure.areas ?? [];

    return (
        <AgTechPageErrorBoundary>
            <Routes>
                <Route path='home' element={(
                    <div className="fading-in stretched flex">
                        {props.app.structure.homePage.workspace()}
                    </div>
                )} />
                {appAreas.map(area => {
                    if (area.workspaces.length > 1) {
                        return area.workspaces.map(workspace => {
                            return (
                                <Route
                                    key={area.name + workspace.name}
                                    path={`${area.name}/${workspace.name}`}
                                    element={(
                                        <div className="fading-in stretched flex">
                                            <workspace.workspace />
                                        </div>
                                    )}
                                />
                            )
                        })
                    }
                    else {
                        const areaWorkspace = area.workspaces[0];
                        
                        return (
                            <Route
                                key={area.name}
                                path={`${area.name}`}
                                element={(
                                    <div className="fading-in stretched flex">
                                        <areaWorkspace.workspace />
                                    </div>
                                )}
                            />
                        )
                    }
                })}
            </Routes>
        </AgTechPageErrorBoundary>
    )
};

const AgTechWebAppBodyMemo = React.memo(AgTechWebAppBody);

export default React.memo(AgTechWebAppSurface);